import type { Dictionary } from "$lib/types/Dictionary";
import { HttpService } from "./HttpService";
import { SPBError } from "./SPBError";



export class DictionaryService extends HttpService {
    constructor() {
        super();
    }

    // Get paginated list of dictionaries
    async getList(skip: number = 0, limit: number = 25): Promise<Dictionary[]> {
        try {
            return (await this.get<Dictionary[]>(`${this.endPointUrl}/api/dictionaries/list`, { params: { skip, limit } })).data.response;
        } catch (error: any) {
            throw new SPBError(error.response.data.err.message);
        }
    }

    async getByPartnerId(partnerId?: string): Promise<Dictionary> {
        try {
            return (await this.get<Dictionary>(`${this.endPointUrl}/api/dictionaries/partner/${partnerId}`)).data.response;
        } catch (error: any) {
            throw new SPBError(error.response.data.err.message);
        }
    }

    // Update dictionary content
    async update(id: string, content: any): Promise<Dictionary> {
        try {
            return (await this.post<Dictionary>(`${this.endPointUrl}/api/dictionaries/update/${id}`, { content })).data.response;
        } catch (error: any) {
            throw new SPBError(error.response.data.err.message);
        }
    }
}